/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseNoteEdictResponse
 */
export interface CaseNoteEdictResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseNoteEdictResponse
     */
    sourceReference: string | null;
}

/**
 * Check if a given object implements the CaseNoteEdictResponse interface.
 */
export function instanceOfCaseNoteEdictResponse(value: object): value is CaseNoteEdictResponse {
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    return true;
}

export function CaseNoteEdictResponseFromJSON(json: any): CaseNoteEdictResponse {
    return CaseNoteEdictResponseFromJSONTyped(json, false);
}

export function CaseNoteEdictResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseNoteEdictResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceReference': json['sourceReference'],
    };
}

export function CaseNoteEdictResponseToJSON(json: any): CaseNoteEdictResponse {
    return CaseNoteEdictResponseToJSONTyped(json, false);
}

export function CaseNoteEdictResponseToJSONTyped(value?: CaseNoteEdictResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceReference': value['sourceReference'],
    };
}

